<template>
	<div class="main">
		<ul class="head">
			<li>{{deviceSid}}</li>
			<li>数据</li>
			<li>{{time}}</li>
		</ul>
		<div class="heart">
			<heart :heartInfo="heartData"></heart>
		</div>
		<div class="breath">
			<breath :breathInfo="breathData"></breath>
		</div>
	</div>
</template>

<script>
	import heart from "./heart.vue"
	import breath from "./breath.vue"
	export default {
		components: {
			heart,
			breath
		},
		data() {
			return {
				deviceSid: "",
				time: '',
				heartData: [],
				breathData: []
			}
		},
		created() {
			this.getData()
			this.deviceSid = window.sessionStorage.getItem("deviceSid")
			this.time = window.sessionStorage.getItem("date")
		},
		methods: {
			getData() {
				let data = new FormData();
				data.append('deviceSid', window.sessionStorage.getItem("deviceSid"));
				data.append('date', window.sessionStorage.getItem("date"));
				data.append('userId', window.sessionStorage.getItem("userId"));
				this.$post("api/getUserMacSleepReport", data).then((res) => {
					window.console.log(res.data.data.hrData)
					window.console.log(res.data.data.rrData)
					this.heartData = res.data.data.hrData
					this.breathData = res.data.data.rrData
					if (res.data.code !== "0000") {
						this.$message({
							message: res.data.message,
							type: 'warning'
						});
					}
				})
			},
		},


	}
</script>

<style scoped="scoped">
	.main {
		width: 100%;
		height: 100%;
		background: #F8F8FF;
	}

	.head {
		background: #fff;
		height: 54px;
		display: flex;
		list-style: none;
		border-bottom: 2px solid #e2e2f2;
		position: relative;
	}

	.head li {
		font-weight: bold;
		position: absolute;
	}

	.head li:first-of-type {
		font-size: 20px;
		left: 2%;
		top: 50%;
		color: #595959;
		transform: translateY(-50%);
	}

	.head li:nth-of-type(2) {
		font-size: 24px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.head li:nth-of-type(3) {
		font-size: 20px;
		right: 2%;
		top: 50%;
		color: #595959;
		transform: translateY(-50%);
	}

	.heart,
	.breath {
		padding: 20px;
		background: #fff;
		margin: 20px auto 50px;
		width: 96%;
		height: 390px;
		border: 2px solid #E6E6FF;
		border-radius: 10px;
	}
</style>
